import styled from "styled-components";

export const InsightsDashboardHeader = styled.div`
  display: flex;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 16px
  }
`;

export const InsightsDashboardHeaderLeft = styled.div`
  flex-grow: 1;
`;

export const InsightsDashboardHeaderRight = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 1rem
`;
